import { decomposeColor } from '@material-ui/core/styles';
import { theme } from '../Theme';
export var getColor = function (color) {
  if (color === void 0) {
    color = 'primary';
  }

  return theme.colors[color + "Color"];
};
export var getRGBColor = function (color) {
  return decomposeColor(color).values.toString();
};
export var getOpacityColor = function (color) {
  return function (opacity) {
    var rgb = getRGBColor(color);
    return "rgba(" + rgb + ", " + opacity + ")";
  };
};
export var getShadow = function (color) {
  var opacityColor = getOpacityColor(color);
  return "\n\t0 2px 2px 0 " + opacityColor(0.14) + ", \n\t0 3px 1px -2px " + opacityColor(0.2) + ", \n\t0 1px 5px 0 " + opacityColor(0.12) + "\n\t";
};
export var getHoverShadow = function (color) {
  var opacityColor = getOpacityColor(color);
  return "\n\t0 14px 26px -12px " + opacityColor(0.42) + ", \n\t0 4px 23px 0px " + opacityColor(0.12) + ", \n\t0 8px 10px -5px " + opacityColor(0.2);
};
export var doopageLogo = 'https://res-2.cloudinary.com/crunchbase-production/image/upload/c_lpad,f_auto,q_auto:eco/argpgshyxeztagczhzqe';
export var listColor = ['#EF4444', '#F59E0B', '#10B981', '#84CC16', '#22C55E', '#06B6D4', '#0EA5E9', '#3B82F6', '#6366F1', '#8B5CF6', '#EC4899', '#F43F5E'];
export var getTextColor = function (background) {
  var _getRGBColor$split = getRGBColor(background).split(','),
      R = _getRGBColor$split[0],
      G = _getRGBColor$split[1],
      B = _getRGBColor$split[2]; // @ts-ignore


  if ((0.299 * R + 0.587 * G + 0.114 * B) / 255 > 0.7) return '#000';
  return '#fff';
};
export var isThemeColor = function (color) {
  return !!theme.colors[color + "Color"];
};